import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,

  state: () => ({
    governorates: [{ value: "", text: "المحافظة" }],
    dataContactUs: [],
    loading: false,
    responseSubmit: {},
    erorrSubmit: false,
    loadingSubmit: false,
  }),

  getters: {
    governorates(state) {
      return state.governorates.map((item) => ({
        value: item.id,
        text: item.name,
      }));
    },
    dataContactUs(state) {
      return state.dataContactUs;
    },
    loading(state) {
      return state.loading;
    },
    getResponseSubmit(state) {
      return state.responseSubmit;
    },
    getErorrSubmit(state) {
      return state.erorrSubmit;
    },
    loadingSubmit(state) {
      return state.loadingSubmit;
    },
  },
  mutations: {
    setGovernorates(state, payload) {
      state.governorates = payload;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setResponseSubmit(state, payload) {
      state.getResponseSubmit = payload;
    },
    setDataContactUs(state, payload) {
      state.dataContactUs = payload;
    },
    setErorrSubmit(state, val) {
      state.erorrSubmit = val;
    },
  },
  actions: {
    async submitContactUs(context, payload) {
      context.state.loadingSubmit = true;
      await api
        .post(ep.submitContact, payload.submitPayload)
        .then((res) => {
          context.state.loadingSubmit = false;
          if (!res.data.status) {
            context.commit("setErorrSubmit", res.data.state);
          }
        })
        .catch((err) => {
          context.state.loadingSubmit = false;
        });
    },

    async getDataContactUs(context, payload) {
      context.commit("setLoading", true);
      await api
        .get(ep.governorates_(payload.id))
        .then((res) => {
          context.commit("setDataContactUs", res.data.data);
          context.commit("setLoading", false);
        })
        .catch((err) => {});
    },
  },
};
